<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <b-modal v-model="isDeleteModal"
             :no-close-on-backdrop="true"
             centered title="Delete modal"
             @cancel="closeDeleteModal"
             @ok="removeItem">
      <form>
        <h3 class="text-black-50">Are you sure want to delete?</h3>
      </form>
    </b-modal>
    <ListingComponent ref="questionList"
                      class="bg-white"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
export default {
  name: 'QuestionListPage',
  data () {
    return {
      id: null,
      isDeleteModal: false,
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            return (
              <b-dropdown variant="link" class="listing-action">
                <b-dropdown-item href={'#/question/edit/' + item.id}>Edit</b-dropdown-item>
                <b-dropdown-item onClick={() => this.showDeleteModal(item)}>Delete</b-dropdown-item>
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'question',
          columnName: 'Question',
          align: 'left',
          value: item => {
            return item.question
          }
        },
        {
          columnCode: 'quiz',
          columnName: 'Quiz',
          align: 'left',
          value: item => {
            if (item.quiz) {
              return item.quiz.name
            } else {
              return ''
            }
          }
        },
        {
          columnCode: 'answerCount',
          columnName: 'Answer Count',
          align: 'left',
          value: item => {
            return item.answerCount || 0
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('question/list', payload)
    },
    addNewButton () {
      return (<router-link class="btn btn-success mr-3" to="/question/add"><div class="icon-plus"></div></router-link>)
    },
    closeDeleteModal () {
      this.id = null
      this.$nextTick(() => {
        this.isDeleteModal = false
      })
    },
    showDeleteModal (item) {
      if (!item.id) {
        this.$toastr.error('Item not found')
      }
      this.id = item.id
      this.isDeleteModal = true
    },
    removeItem () {
      if (!this.id) {
        return
      }
      this.$loading.show(true)
      this.axios.delete('question/item', {params: {id: this.id}})
        .then((result) => {
          this.$refs.questionList.doRequest()
          this.$loading.hide()
          if (result && result.data && result.data.status === 200) {
            this.$toastr.success('successfully deleted')
          }
          this.isDeleteModal = false
        })
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/question/QuestionListPage.vue